export const cssBundleHref = "/build/css-bundle-VMCAEJXL.css";